import AppComponent from '../base/app-component.ts';

type CodiceCassa = 'CE' | 'EC';

interface RangeState {
  loading: boolean;
  error: string | null;
  range: {
    periodoInizio: string;
    periodoFine: string;
    nPeriodi: number;
  } | null;
}

interface State {
  CE: RangeState;
  EC: RangeState;
  eseguendo: CodiceCassa | null;
}

interface CassaView {
  codice: CodiceCassa;
  nome: string;
  loading: boolean;
  error: string | null;
  hasRange: boolean;
  periodoInizio: string;
  periodoFine: string;
  nPeriodi: number;
}

const CASSE: { codice: CodiceCassa; nome: string }[] = [
  { codice: 'CE', nome: 'Cassa Edile (CE)' },
  { codice: 'EC', nome: 'Edilcassa (EC)' },
];

export class StatisticheSetup extends AppComponent {
  static override componentName = 'wc-statistiche-setup';

  protected override get templateId() { return 'statistiche-setup'; }

  private state: State = {
    CE: { loading: true, error: null, range: null },
    EC: { loading: true, error: null, range: null },
    eseguendo: null,
  };

  protected override onConnected(): void {
    this.render();
    void this.caricaTutte();
  }

  protected override buildRenderingData(): Record<string, unknown> {
    return {
      casse: CASSE.map(cassa => this.buildCassaView(cassa.codice, cassa.nome)),
      overlay: this.state.eseguendo !== null,
    };
  }

  protected override afterRender(): void {
    this.delegate.on('click', '[data-action="esegui"]', (e: Event) => {
      const btn = (e.target as HTMLElement).closest('[data-action="esegui"]') as HTMLElement;
      const cassa = btn.dataset.cassa as CodiceCassa | undefined;
      if (!cassa) return;
      void this.esegui(cassa);
    });
  }

  private async caricaTutte(): Promise<void> {
    await Promise.all(CASSE.map(cassa => this.caricaCassa(cassa.codice)));
  }

  private async caricaCassa(cassa: CodiceCassa): Promise<void> {
    const result = await this.api.statistiche.range(cassa);
    const slot = this.state[cassa];
    slot.loading = false;

    if (!result.ok) {
      slot.error = result.error;
      this.render();
      return;
    }

    slot.range = result.data.range
      ? {
          periodoInizio: result.data.range.periodoInizio,
          periodoFine: result.data.range.periodoFine,
          nPeriodi: result.data.range.nPeriodi,
        }
      : null;
    this.render();
  }

  private async esegui(cassa: CodiceCassa): Promise<void> {
    const range = this.state[cassa].range;
    if (!range || range.nPeriodi < 1) return;

    this.state.eseguendo = cassa;
    this.render();

    const result = await this.api.statistiche.calcola(cassa);
    if (!result.ok) {
      this.state.eseguendo = null;
      this.render();
      (globalThis as unknown as { Weext?: { toast: (msg: string, opts?: unknown) => void } }).Weext
        ?.toast(result.error, { type: 'danger' });
      return;
    }

    window.location.href = `/statistiche/${result.data.nomeTabella}`;
  }

  private buildCassaView(codice: CodiceCassa, nome: string): CassaView {
    const { loading, error, range } = this.state[codice];
    return {
      codice,
      nome,
      loading,
      error,
      hasRange: !!range,
      periodoInizio: range?.periodoInizio ?? '',
      periodoFine: range?.periodoFine ?? '',
      nPeriodi: range?.nPeriodi ?? 0,
    };
  }
}
